import { absolutePath } from "./absolutePath";

export const emailHubSubscription = {
  cancel: (reason: string, reasonDescription: string) =>
    absolutePath("email_hub/subscriptions/cancel", {
      reason: reason,
      reason_description: reasonDescription,
    }),
};
